"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactSoundcloud = function (_Component) {
  _inherits(ReactSoundcloud, _Component);

  function ReactSoundcloud() {
    _classCallCheck(this, ReactSoundcloud);

    return _possibleConstructorReturn(this, (ReactSoundcloud.__proto__ || Object.getPrototypeOf(ReactSoundcloud)).apply(this, arguments));
  }

  _createClass(ReactSoundcloud, [{
    key: "render",
    value: function render() {
      var _props = this.props;
      var url = _props.url;
      var width = _props.width;
      var height = _props.height;
      var autoPlay = _props.autoPlay;
      var hideRelated = _props.hideRelated;
      var showComments = _props.showComments;
      var showUser = _props.showUser;
      var showReposts = _props.showReposts;
      var visual = _props.visual;
      var color = _props.color;


      var src = visual ? "https://w.soundcloud.com/player/?url=" + url + "&amp;auto_play=" + autoPlay + "&amp;hide_related=" + hideRelated + "&amp;show_comments=" + showComments + "&amp;show_user=" + showUser + "&amp;show_reposts=" + showReposts + "&amp;visual=" + visual : "https://w.soundcloud.com/player/?url=" + url + "&amp;color=" + color + "&amp;auto_play=" + autoPlay + "&amp;hide_related=" + hideRelated + "&amp;show_comments=" + showComments + "&amp;show_user=" + showUser + "&amp;show_reposts=" + showReposts;

      return _react2.default.createElement("iframe", {
        width: width,
        height: visual ? height : "auto",
        scrolling: "no",
        frameBorder: "no",
        src: src });
    }
  }]);

  return ReactSoundcloud;
}(_react.Component);

ReactSoundcloud.defaultProps = {
  width: "100%",
  height: "80px",
  url: "",
  autoPlay: false,
  hideRelated: false,
  showComments: true,
  showUser: true,
  showReposts: false,
  visual: true,
  color: "ff5500"
};
exports.default = ReactSoundcloud;
